export default "__VITE_ASSET__39dd8b18__"